"use client";
import { cn as e } from "../../design/cn.js";
import "react";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
// src/components/data-table/DataTableBulkBar.tsx
var r = ({ selectedCount: r, selectedRowIds: i, selectedRows: a, bulkActions: o, position: s }) => r === 0 ? null : /* @__PURE__ */ n("div", {
	className: e("flex items-center justify-between gap-3 px-4 py-2 text-xs bg-secondary text-primary", s === "top" ? "border-b border-border" : "border-t border-b border-border"),
	children: [/* @__PURE__ */ n("div", {
		className: "font-medium",
		children: [r, " selected"]
	}), /* @__PURE__ */ t("div", { children: typeof o == "function" ? o({
		selectedRowIds: i,
		rows: a
	}) : o })]
});
r.displayName = "BulkActionsBar";
export { r as BulkActionsBar };

//# sourceMappingURL=DataTableBulkBar.js.map